
import { Link } from 'react-router-dom';
import NavBar from '../../components/feature/NavBar';
import Process from '../home/components/Process';
import SEOHead from '../../components/feature/SEOHead';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://zjfitservices.com';

const processJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Our IT Deployment Process | ZJF IT Services LLC',
    description: 'Discover the structured, reliable IT deployment process used by ZJF IT Services LLC — from discovery and planning to execution and sign-off, ensuring operational readiness from day one.',
    url: `${siteUrl}/process`,
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
        { '@type': 'ListItem', position: 2, name: 'Our Process', item: `${siteUrl}/process` },
      ],
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'HowTo',
    name: 'ZJF IT Services Deployment Process',
    description: 'A structured, reliable approach to every IT deployment project — from discovery to completion.',
    step: [
      { '@type': 'HowToStep', position: 1, name: 'Discovery & Scoping', text: 'We assess your environment, requirements, and timeline to build a precise deployment plan.' },
      { '@type': 'HowToStep', position: 2, name: 'Planning & Logistics', text: 'Equipment staging, team coordination, and site preparation are handled before day one.' },
      { '@type': 'HowToStep', position: 3, name: 'On-Site Execution', text: 'Our certified technicians execute the deployment with precision and minimal disruption.' },
      { '@type': 'HowToStep', position: 4, name: 'Quality Assurance', text: 'Every workstation and connection is tested and verified against project specifications.' },
      { '@type': 'HowToStep', position: 5, name: 'Sign-Off & Handover', text: 'Full documentation and client sign-off ensure operational readiness from day one.' },
    ],
  },
];

export default function ProcessPage() {
  return (
    <div className="min-h-screen bg-zinc-950">
      <SEOHead
        title="Our IT Deployment Process | ZJF IT Services LLC"
        description="Discover the structured, reliable IT deployment process used by ZJF IT Services LLC — from discovery and planning to execution and sign-off, ensuring operational readiness from day one."
        keywords="IT deployment process, structured IT rollout, workstation deployment steps, IT project management New York, field services process"
        canonical={`${siteUrl}/process`}
        jsonLd={processJsonLd}
      />
      <NavBar />
      <div className="pt-20">
        <div className="py-16 bg-zinc-950 text-center border-b border-zinc-800">
          <span className="text-orange-500 text-sm font-semibold uppercase tracking-widest mb-3 block">How We Work</span>
          <h1 className="text-5xl font-bold text-white mb-4">Our Process</h1>
          <p className="text-zinc-400 text-lg max-w-2xl mx-auto">
            A structured, reliable approach to every IT deployment project — from discovery to completion.
          </p>
        </div>
        <Process />
        <div className="py-16 bg-zinc-950 text-center">
          <Link
            to="/contact"
            className="bg-orange-500 hover:bg-orange-600 text-white px-10 py-4 rounded-md text-base font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer inline-block"
          >
            Start Your Project
          </Link>
        </div>
      </div>
    </div>
  );
}
